import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { projectListSelectors } from "store/selectors";
import { getProjectSummary, setProjectSearchBar } from "store/actions/projectList";
import DashboardView from "containers/DashboardView";
import LoadingIndicator from '@cayuse/shared-react.components.loading-indicator';


const ProjectDashboard = ({ dashboardTilesAriaControls }) => {
	const [ activeSummary, setActiveSummary ] = useState(null);
	const { search } = useSelector(projectListSelectors.content);
	const { items, isFetching } = useSelector(projectListSelectors.summary);

	useEffect(() => {
		getProjectSummary();
	}, []);

	useEffect(() => {
		if (search?.val) {
			setActiveSummary(search?.val);
		} else {
			setActiveSummary(null);
		}
	}, [ search ]);

	const onTileClick = value => {
		const activeSearch = search && search.val !== value
			? { key: "status", val: value }
			: {};

		const activeSummary = isNonEmptyString(activeSearch.val) ? activeSearch.val : null;

		setProjectSearchBar(activeSearch);
		setActiveSummary(activeSummary);
	};

	if (isFetching) {
		return <LoadingIndicator />;
	}

	return (
		<>
			<h3 className="accessibility-text">Projects</h3>
			<p className="accessibility-text">
				Use the buttons to filter the list of projects by status.
			</p>
			<DashboardView
				summary={items}
				onTileClick={onTileClick}
				activeTile={activeSummary}
				dashboardTopic="projects"
				dashboardTilesAriaControls={dashboardTilesAriaControls}
			/>
		</>
	);
};

ProjectDashboard.propTypes = {
	dashboardTilesAriaControls: PropTypes.string
};

export default ProjectDashboard;
